import { ProgressBar } from './progress-bar.component';
import { ProgressBarItem } from './progress-bar-item/progress-bar-item.component';

export * from './progress-bar-item/progress-bar-item.component';
export * from './progress-bar.component.js';
export default ProgressBar;

ProgressBar.define('der-ui-progress-bar');
ProgressBarItem.define('der-ui-progress-bar-item');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-progress-bar': ProgressBar;
    }
    interface HTMLElementTagNameMap {
        'der-ui-progress-bar-item': ProgressBarItem;
    }
}
